import React, { useRef, useState } from 'react';
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';
import { apiUrl } from '../../config';

export default function ChangeEmailDialog({
  user,
  token,
  open,
  onClose,
  onChanged,
}) {
  const [email, setEmail] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const inFlight = useRef(false);

  async function submit(event) {
    event.preventDefault();
    if (inFlight.current || !token) return;
    inFlight.current = true;
    setSaving(true);
    setError('');
    try {
      const response = await fetch(
        `${apiUrl}/api/admin/users/${user._id}/change_email`,
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ email: email.trim().toLowerCase() }),
        }
      );
      const body = await response.json().catch(() => ({}));
      if (!response.ok || !body.user?.email) {
        throw new Error(
          body.message ||
            'Unable to change the email address. Please try again.'
        );
      }
      onChanged(body.user);
      onClose();
    } catch (failure) {
      setError(
        failure.message ||
          'Unable to change the email address. Please try again.'
      );
    } finally {
      inFlight.current = false;
      setSaving(false);
    }
  }

  return (
    <Dialog
      open={open}
      onClose={() => {
        if (!saving) onClose();
      }}
      fullWidth
      maxWidth="sm"
      aria-labelledby="change-email-title"
    >
      <form onSubmit={submit}>
        <DialogTitle id="change-email-title">Change email</DialogTitle>
        <DialogContent>
          <Typography sx={{ mb: 2 }}>
            Current email: {user.email || 'None'}. This changes the account’s
            sign-in email.
          </Typography>
          <TextField
            autoFocus
            fullWidth
            required
            type="email"
            label="New email"
            value={email}
            disabled={saving}
            onChange={(event) => setEmail(event.target.value)}
            inputProps={{ maxLength: 254 }}
            sx={{ mt: 1 }}
          />
          {error && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {error}
            </Alert>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} disabled={saving}>
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            disabled={
              saving ||
              !token ||
              !email.trim() ||
              email.trim().toLowerCase() === user.email
            }
          >
            {saving ? 'Saving…' : 'Save email'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
